// Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

// Local
import { UserGroup } from '@app/types/user/user-permissions';
import { AuthService } from '@core/auth/auth.service';

export const canModifyOrg: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  
  const authService = inject(AuthService);
  return (authService.userPermissions.canModifyOrg)
   && (
    authService.userPermissions.userType == UserGroup.Court 
    || 
    authService.userPermissions.userType == UserGroup.LawFirm
   );
};
